import { Route } from 'react-router-dom';
import { ListParticipationsPage } from './list-participations';
import { RequireAuth } from '/src/components';

export { ListParticipationsPage };

export const participationsRoutes: React.ReactElement[] = [
  <Route
    path="/participations"
    element={
      <RequireAuth>
        <ListParticipationsPage />
      </RequireAuth>
    }
  />,
];
